<template>
  <div>
    <div class="header flex justify-center bg-green-10 py-3">
      <UtilsIcon
        name="LogoTopFarmaciaOnline.svg"
        class="h-12 w-full max-w-[150px]"
      />
    </div>
    <slot class="overflow-x-hidden" />
  </div>
</template>
